"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
// import { Timer } from '@l2p/ui-components'
var next_intl_1 = require("next-intl");
var DayOfWeekTimer = function (_a) {
    var activeDayOfWeek = _a.activeDayOfWeek, hideFinishLabel = _a.hideFinishLabel;
    var t = (0, next_intl_1.useTranslations)('translation');
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    // const promoActive = useMemo(() => {
    //   return checkPromoDay(activeDayOfWeek)
    // }, [activeDayOfWeek])
    return null;
    // return (
    //   <>
    //     {promoActive?.active ? (
    //       <div className={styles.active}>{t('active')}</div>
    //     ) : (
    //       <div className={styles.timerWrapper}>
    //         <Timer
    //           endDate={promoActive?.startAt}
    //           inGame={breakpoints.mobile || breakpoints.tablet}
    //           title={t('startAfter')}
    //           hideFinishLabel={hideFinishLabel}
    //         />
    //       </div>
    //     )}
    //   </>
    // )
};
exports.default = DayOfWeekTimer;
